import noticePdf from "../../../assets/update_folder/noticepdf-ead74eceb221cb167747d80dbfbc48ee.pdf";
import actPdf from "../../../assets/update_folder/Act_2013.pdf";
import ccpdAuditPdf from "../../../assets/tenders/RFP for CCPD Audit 2026.pdf";
import manfAadharPdf from "../../../assets/update_folder/MANF_Aadharlinkpdf-59ec4c0832ce10a16d6eba76a8d6d747.pdf";
import finalResultPdf from "../../../assets/update_folder/FinaLAM-Result-pdf-baa6887c73f81dd63a2b61abe5fec2cd.pdf";
import advertisementPdf from "../../../assets/updates_pdf/Advertisementpdf.pdf";
import RecruitmentAdvertisement from "../../../assets/updates_pdf/RecruitmentAdvertisement.pdf";

export const updates = [
  {
    title: "Engagement of Web Accessibility Auditor for NMDFC Website, Web Applications and Integrated AI Chatbot",
    date: "07 Oct 2026",
    fileName: "RFP for CCPD Audit 2026.pdf",
    href: ccpdAuditPdf,
    route: "/career/active-tenders",
  },
  {
    title:
      "Company Secretary cum Chief Manager (Corporate Services) [IDA - E-3: ₹60,000-1,80,000]",
    date: "25 Aug 2026",
    fileName: "Advertisementpdf.pdf",
    href: advertisementPdf,
    route: "/career/available-opportunities",
  },
  {
    title: "Engagement as Senior Legal Advisor on a contractual basis",
    date: "25 Aug 2026",
    fileName: "RecruitmentAdvertisement.pdf",
    href: RecruitmentAdvertisement,
    route: "/career/available-opportunities",
  },
  {
    title: "MANF-Update Aadhar details on Scholarship Fellowship Management Portal",
    date: "15 Jan 2026",
    fileName: "MANF_Aadharlinkpdf-59ec4c0832ce10a16d6eba76a8d6d747.pdf",
    href: manfAadharPdf,
  },
  {
    title:
      "Final Result of Assistant Managers (Direct Recruitment Examination Held on 28.09.2025)",
    date: "28 Sep 2025",
    fileName: "FinaLAM-Result-pdf-baa6887c73f81dd63a2b61abe5fec2cd.pdf",
    href: finalResultPdf,
  },
  {
    title: "Notice - Arrears of the Maulana Azad National Fellowship (MANF) Scheme",
    date: "24 Oct 2024",
    fileName: "noticepdf-ead74eceb221cb167747d80dbfbc48ee.pdf",
    href: noticePdf,
  },
  {
    title:
      "The Internal Complaint Committee (ICC) on the Sexual Harassment of Women at Workplace (Prevention, Probation and Redressal) Act, 2013",
    date: "05 Sep 2024",
    fileName: "Act_2013.pdf",
    href: actPdf,
  },
];
